module.exports = __webpack_public_path__ + "static/funnels2-438beb74407367925336d5a7e15c0f1e.png";